import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Stack } from '@guestyci/arc';
import { Asterisk, MessageSquareText, Mail, Fingerprint } from '@guestyci/icons/system';
import { utils } from 'utils';

const MFA_OPTIONS = [
  {
    key: 'biometric',
    icon: Fingerprint,
    title: () => t('Biometric login or security key'),
    description: () => t('Use a biometric login or security key, such as Touch ID or Face ID.'),
    buttonLabel: () => t('Set up'),
  },
  {
    key: 'googleAuthenticator',
    icon: Asterisk,
    title: () => t('Google authenticator'),
    description: () => t('Secure login with the Google Authenticator app'),
    buttonLabel: () => t('Set up Google Authenticator'),
  },
  {
    key: 'sms',
    icon: MessageSquareText,
    title: () => t('SMS authentication'),
    description: () => t('Receive verification codes via text message'),
    buttonLabel: () => t('Use SMS verification'),
  },
  {
    key: 'email',
    icon: Mail,
    title: () => t('Email authentication'),
    description: () => t('Get verification codes sent to your email'),
    buttonLabel: () => t('Use email verification'),
  },
];

const MfaOptionCard = ({ icon: Icon, title, description, buttonLabel, onSelect }) => (
  <Stack spacing={3} direction="row" align="start" className="gst-w-full">
    <div className="gst-flex gst-items-center gst-justify-center gst-rounded-full gst-bg-success-foreground gst-w-12 gst-h-12 gst-shrink-0">
      <Icon className="gst-size-6 gst-text-primary" aria-hidden="true" />
    </div>
    <Stack spacing={3} direction="column" className="gst-flex-1 gst-min-w-0">
      <Stack spacing={1} direction="column">
        <Text className="gst-font-medium">{title()}</Text>
        <Text type="secondary">{description()}</Text>
      </Stack>
      <Button
        variant="secondary"
        className="gst-w-full"
        onClick={onSelect}
      >
        {buttonLabel()}
      </Button>
    </Stack>
  </Stack>
);

const CustomMFA = ({ mfaConfig }) => {
  const logEvent = utils.eventsLogger?.unifiedLoginDio?.track;

  const visibleOptions = MFA_OPTIONS.filter((option) => mfaConfig?.[option.key]?.available);

  const handleOptionSelect = (optionKey) => {
    if (logEvent) {
      logEvent('registration_MFA', 'click', { method: optionKey });
    }
    mfaConfig?.[optionKey]?.onSelect?.();
  };

  if (!mfaConfig) return null;

  return (
    <Stack spacing={7} direction="column" className="gst-w-full">
      {visibleOptions.map((option) => (
        <MfaOptionCard
          key={option.key}
          icon={option.icon}
          title={option.title}
          description={option.description}
          buttonLabel={option.buttonLabel}
          onSelect={() => handleOptionSelect(option.key)}
        />
      ))}
    </Stack>
  );
};

export default CustomMFA;
